/* eslint-disable import/no-anonymous-default-export */
import auth from './auth.json';
import dialog from './dialog.json';
import table from './table.json';
import page from './page.json';
import model from './model.json';

export default { auth, dialog, table, page, model };
